import React, { useEffect } from 'react';

/**
 * Background video component for hero sections
 * Uses Vimeo embed for the restaurant's promotional video
 */
const BackgroundVideo = () => {
  useEffect(() => {
    // Load Vimeo player script
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script if component unmounts
      const existingScript = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
      <div 
        className="absolute inset-0 w-full h-full"
        style={{
          padding: '0',
          position: 'relative',
          width: '100%',
          height: '100%'
        }}
      >
        <iframe 
          src="https://player.vimeo.com/video/1088495090?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479&autoplay=1&loop=1&muted=1&background=1" 
          frameBorder="0" 
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" 
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }}
          title="Ultimate Bar and Grill Video"
        />
      </div>
      
      {/* Fallback background image if video fails to load */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat -z-10"
        style={{
          backgroundImage: 'url("/images/backgrounds/interior-bg.webp")'
        }}
      />
    </div>
  );
};

export default BackgroundVideo;
